import { render, staticRenderFns } from "./AccountReports.vue?vue&type=template&id=97162458&scoped=true&"
import script from "./AccountReports.vue?vue&type=script&lang=js&"
export * from "./AccountReports.vue?vue&type=script&lang=js&"
import style0 from "./AccountReports.vue?vue&type=style&index=0&id=97162458&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97162458",
  null
  
)

export default component.exports